import React, { useState, useEffect } from 'react';
import { Size } from '../../../styles/theme.mjs';
import ButtonComponent from '../../Basic/Button/Button.mjs';
import Checkbox from '../../Basic/Checkbox/Checkbox.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import { StyledModalContainer, StyledList, StyledListLabel, StyledListItemHeading, StyledListItemText } from './NewsletterModal.styles.mjs';

const NewsletterModal = ({ title, subscriptions, onClose, onSubmit }) => {
    const [selectedNames, setSelectedNames] = useState(new Set());
    useEffect(() => {
        const selectedSubscriptionsNames = subscriptions.reduce((acc, { checked, name }) => {
            if (checked)
                acc.add(name);
            return acc;
        }, new Set());
        setSelectedNames(selectedSubscriptionsNames);
    }, [subscriptions]);
    const handleCheckboxChange = (name) => () => {
        setSelectedNames(prevSelected => {
            const nextSelected = new Set(prevSelected);
            nextSelected.has(name) ? nextSelected.delete(name) : nextSelected.add(name);
            return nextSelected;
        });
    };
    const handleSubmit = () => {
        onSubmit(subscriptions.map(subscription => (Object.assign(Object.assign({}, subscription), { checked: selectedNames.has(subscription.name) }))));
    };
    return (React.createElement(StyledModalContainer, { enableOverlay: true, title: title, onClose: onClose },
        React.createElement(StyledList, null, subscriptions.map(({ name, title, description }) => (React.createElement("li", { key: name },
            React.createElement(StyledListLabel, null,
                React.createElement(Checkbox, { checked: selectedNames.has(name), onChange: handleCheckboxChange(name) }),
                React.createElement(FlexContainer, { direction: "column", gap: "0.5rem" },
                    React.createElement(StyledListItemHeading, { tag: "h3" }, title),
                    React.createElement(StyledListItemText, { size: Size.Tiny, tag: "p" }, description))))))),
        React.createElement(ButtonComponent, { ariaLabel: "Subscribe to newsletter", type: "button", onClick: handleSubmit }, "Sign Up")));
};

export { NewsletterModal as default };
//# sourceMappingURL=NewsletterModal.mjs.map
